






































































































import * as R from 'ramda'
import axios from 'axios'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import { ActionNames, GetterNames } from '@/store/modules/exercise-program/keys'
import { ActionNames as PatientActionNames } from '@/store/modules/patient/keys'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { ActionNames as PatientExerciseActionNames } from '@/store/modules/exercise/keys'
import { UserActionContexts } from '@/constants/urls'
import { ModuleNames } from '@/store/module-names'
import { getMorningAfternoonEvening } from '@/utils/time'

import ExerciseProgramDetailsDialog from '@/components/exercise-programs/forms/ExerciseProgramDetailsDialog.vue'
import ExerciseProgramDetail from '@/components/exercise-programs/ExerciseProgramDetail.vue'

type ComponentData = {
  activeTab: number
  exerciseProgramsForTabs: any[]
  isFetchingInitialData: boolean
  isDeletingExerciseProgramData: boolean
  showExerciseProgramDetailsDialog: boolean
  showConfirmStartLiveSessionDialog: boolean
  exerciseProgramDetailsDialogActionContext: UserActionContexts.New | UserActionContexts.Edit
}

export default Vue.extend({
  components: {
    ExerciseProgramDetail,
    ExerciseProgramDetailsDialog,
  },
  data(): ComponentData {
    return {
      activeTab: 0,
      exerciseProgramsForTabs: [],
      isFetchingInitialData: true,
      isDeletingExerciseProgramData: false,
      showExerciseProgramDetailsDialog: false,
      showConfirmStartLiveSessionDialog: false,
      exerciseProgramDetailsDialogActionContext: UserActionContexts.New,
    }
  },
  computed: {
    showLoading(): boolean {
      return this.isFetchingInitialData || this.isDeletingExerciseProgramData
    },
    timeOfDay() {
      return getMorningAfternoonEvening()
    },
    hasExercisePrograms() {
      return !R.isEmpty(this.exercisePrograms)
    },
    chosenExerciseProgram() {
      return this[GetterNames.chosenExerciseProgram]
    },
    hasSiteStatses() {
      return !R.isEmpty(this.siteStatses)
    },
    ...mapGetters(ModuleNames.exerciseProgram, {
      exercisePrograms: GetterNames.exercisePrograms,
      chosenExerciseProgram: GetterNames.chosenExerciseProgram,
      chosenExerciseProgramId: GetterNames.chosenExerciseProgramId,
    }),
    ...mapGetters(ModuleNames.siteStats, {
      siteStatses: SiteStatsGetterNames.siteStatses,
    }),
  },
  async mounted(): Promise<void> {
    await this[ActionNames.getExercisePrograms]()
    await this[PatientActionNames.getPatients]()
    this.getExerciseProgramsForTabs()
    if (this.chosenExerciseProgramId) {
      this.tabToChosenProgram()
    } else if (this.hasExercisePrograms) {
      this[ActionNames.setChosenExerciseProgramId](this.exercisePrograms[0].id)
    }
    this.isFetchingInitialData = false
    /* This call is outside the 'show loading' logic as it often takes quite a while and would otherwise delay page render. Might be worth adding a lighter API call in future. Sitestats are required for creating/editing programs.*/
    await this[SiteStatsActionNames.getSiteStatses]()
  },
  methods: {
    handleTabChange(e) {
      const chosenProgramId = this.exercisePrograms[e].id
      this[ActionNames.setChosenExerciseProgramId](chosenProgramId)
    },
    tabToChosenProgram() {
      this.activeTab = R.findIndex(R.propEq('id', this.chosenExerciseProgramId))(this.exercisePrograms)
    },
    closeExerciseProgramDetailsDialog() {
      this.showExerciseProgramDetailsDialog = false
    },
    closeConfirmStartLiveSessionDialog() {
      this.showConfirmStartLiveSessionDialog = false
    },
    startLiveExerciseSession() {
      this.showConfirmStartLiveSessionDialog = false
      this.$router.push({
        name: 'new-exercise-session',
        params: {
          program_id: this.chosenExerciseProgram.id,
          context: UserActionContexts.New,
        },
      })
    },
    newExerciseProgram() {
      this.exerciseProgramDetailsDialogActionContext = UserActionContexts.New
      this.showExerciseProgramDetailsDialog = true
    },
    editExerciseProgram() {
      this.exerciseProgramDetailsDialogActionContext = UserActionContexts.Edit
      this.showExerciseProgramDetailsDialog = true
    },
    handleNewExerciseProgram() {
      this.getExerciseProgramsForTabs()
      this.tabToChosenProgram()
    },
    async deleteExerciseProgram(e) {
      this.isDeletingExerciseProgramData = true
      await this[ActionNames.deleteExerciseProgram](e)
      this.getExerciseProgramsForTabs()
      this.handleTabChange(0)
      this.activeTab = 0
      this.isDeletingExerciseProgramData = false
    },
    async deleteExerciseSession(e) {
      this.isDeletingExerciseProgramData = true
      console.log(`deleting exercise session ${e.exerciseSessionId}`)
      await this[ActionNames.deleteExerciseProgramSession](e.exerciseSessionId)
      const patientExerciseDeleteArray = []
      e.patientExerciseIds.forEach(ref => {
        patientExerciseDeleteArray.push(
          this[PatientExerciseActionNames.deleteExercise]({
            exerciseId: ref.exerciseId,
          })
            .then(res => console.log(`deleted exercise record ${ref.exerciseId} for patient ${ref.patientId}`))
            .catch(err =>
              console.log(`failed to delete exercise record ${ref.exerciseId} for patient ${ref.patientId}`)
            )
        )
      })
      if (!R.isEmpty(patientExerciseDeleteArray)) {
        await axios.all(patientExerciseDeleteArray)
      }
      this.isDeletingExerciseProgramData = false
    },
    getExerciseProgramsForTabs() {
      console.log(this.exercisePrograms)
      this.exerciseProgramsForTabs = this.exercisePrograms.map(program => ({
        id: program.id,
        title: program.title,
      }))
    },
    ...mapActions(ModuleNames.exerciseProgram, [
      ActionNames.getExercisePrograms,
      ActionNames.setChosenExerciseProgramId,
      ActionNames.deleteExerciseProgram,
      ActionNames.deleteExerciseProgramSession,
    ]),
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    ...mapActions(ModuleNames.exercise, [PatientExerciseActionNames.deleteExercise]),
  },
})
